import {accountingService} from "@/common/api.service";

const initialStates = {
    accounts: [],
    transactions: [],
    loading: false
};


const getters = {
    accounts: ({ accounts }) => accounts,
    transactions: ({ transactions }) => transactions,
    loading: ({ loading }) => loading
};

const mutations = {
    accountsList(state, accounts) {
        state.accounts = accounts;
    },
    transactionsList(state, transactions) {
        state.transactions = transactions;
    },
    loading(state) {
        state.loading = true;
    },
    loaded(state) {
        state.loading = false;
    }
};

const actions = {
    fetchAccounts({ commit }) {
        commit("loading");
        return accountingService.getAllAccounts().then(response => {
            commit("accountsList", response.data.data);
            commit("loaded");
        });
    },
    fetchTransactions({ commit }, params) {
        commit("loading");
        return accountingService.getAccountTransactions(params).then(response => {
            commit("transactionsList", response.data.data);
            commit("loaded");
        });
    }
};


export default {
    namespaced: true,
    state: initialStates,
    getters: getters,
    actions: actions,
    mutations: mutations,
};